import { render } from "./MWHomePage.vue?vue&type=template&id=5c12fc62&scoped=true"
import script from "./MWHomePage.vue?vue&type=script&lang=js"
export * from "./MWHomePage.vue?vue&type=script&lang=js"

import "./MWHomePage.vue?vue&type=style&index=0&id=5c12fc62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c12fc62"]])

export default __exports__